export function formatDate(date, withTime = false) {
    if(withTime) {
        return moment(date).format("DD/MM/YYYY H:mm:ss");
    }

    return moment(date).format("DD/MM/YYYY");
}

export function formattedDiffDate(dateValue) {
    if (!dateValue) return '';

    const date = new Date(dateValue);

    const parts = new Intl.DateTimeFormat('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC' // <-- essencial, evita o shift de dia
    }).formatToParts(date);

    const get = (type) => parts.find(p => p.type === type)?.value || '';

    const weekday = get('weekday');
    const day = get('day');
    const month = get('month');
    const year = get('year');

    // "quarta-feira 26, agosto 2026"
    return `${weekday} ${day}, ${month} ${year}`
        .replace(/^\w/, c => c.toUpperCase()); // capitaliza a primeira letra
}

export function maskForIE(uf) {
    const IE_MASKS = {
        AC: '##.###.###/###-##',
        AL: '#########',
        AP: '#########',
        AM: '##.###.###-#',
        BA: '#######-##',
        CE: '########-#',
        DF: '##.######.###-##',
        ES: '###.###.##-#',
        GO: '##.###.###-#',
        MA: '##.###.###-#',
        MT: '##########-#',
        MS: '##.###.###-#',
        MG: '###.###.###/####',
        PA: '##-######-#',
        PB: '##.###.###-#',
        PR: '########-##',
        PE: '#######-##',
        PI: '##.###.###-#',
        RJ: '##.###.##-#',
        RN: '##.###.###-#',
        RS: '###/#######',
        RO: '#############-#',
        RR: '########-#',
        SC: '###.###.###',
        SP: '###.###.###.###',
        SE: '########-#',
        TO: '##.###.###-#',
    }
    
    if (!uf) return ''
    return IE_MASKS[String(uf).trim().toUpperCase()] ?? ''
}

export function maskPhoneNumber(value) {
  const cleanValue = value.replace(/\D/g, "")

  if (cleanValue.length === 0) {
    return ""
  }

  if (cleanValue.length <= 2) {
    return `(${cleanValue}`
  }

  if (cleanValue.length <= 7) {
    return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2)}`
  }

  if (cleanValue.length <= 11) {
    return `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2, 7)}-${cleanValue.slice(7, 11)}`
  }

  return value
}

/**
 * Formata o input para um valor monetario.
 * @param {*} value 
 * @returns 
 */
export function formatCurrency(value) {
    if (value) {
        const convert = Number(value);

        return convert.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    }

    return 'R$ 0,00'
}

export function formatCPF(value) {
    if (!value) return "";

    const valorLimpo = value.toString().replace(/\D/g, "");

    if (valorLimpo.length === 0) return "";

    const mask = "###.###.###-##"

    let valorFormatado = "";
    let i_valor = 0;

    for (let i_mask = 0; i_mask < mask.length; i_mask++) {
    
    if (i_valor >= valorLimpo.length) break;

    if (mask[i_mask] === "#") {
        valorFormatado += valorLimpo[i_valor];
        i_valor++;
    } else {
        valorFormatado += mask[i_mask];
    }
    }

    return valorFormatado;
}

export function formatCNPJ(value) {
    if (!value) return "";

    const valorLimpo = value.toString().replace(/\D/g, "");

    if (valorLimpo.length === 0) return "";

    const mask = "##.###.###/####-##"

    let valorFormatado = "";
    let i_valor = 0;

    for (let i_mask = 0; i_mask < mask.length; i_mask++) {
    
    if (i_valor >= valorLimpo.length) break;

    if (mask[i_mask] === "#") {
        valorFormatado += valorLimpo[i_valor];
        i_valor++;
    } else {
        valorFormatado += mask[i_mask];
    }
    }

    return valorFormatado;
}

export function formatClear(value) {
    const cleanText = value.replace(/\D/g, "");

    return cleanText;
}


// WEBPACK FOOTER //
// ./resources/assets/js/util/formatters.js